/*
 * @Author: Json Chen
 * @Date: 2021-06-30 15:43:21
 * @LastEditTime: 2021-07-01 18:09:20
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ModalDelHOC/index.tsx
 */
/*
 * @Author: Json Chen
 * @Date: 2021-06-30 15:24:58
 * @LastEditTime: 2021-06-30 15:24:58
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/ModalTips/index.tsx
 */

import React from 'react';
import { Modal } from 'antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

/*
  modalDataStrategy  Example :  {
    confirm: {
      title: 'title',
      content: 'content',
      buttonType: 'primary',
      okText: 'Confirm',
    },
    delete: {
      title: 'title',
      content: 'content',
      buttonType: 'danger',
      okText: 'Delete',
    },
  };

*/
type ModalDelHOCConfig = {
  modalDataStrategy: any;
  canDel: (args: { list: any[]; index: number }) => boolean;
  getDelReason?: (args: { list: any[]; index: number }) => string | null;
};

const DEFAULTMODALDATA: any = {
  title: 'Title',
  content: 'Content',
  buttonType: 'primary',
  okText: 'Confirm',
};

const ModalDelHOC = (
  Comp,
  { modalDataStrategy, canDel, getDelReason }: ModalDelHOCConfig,
) => {
  const WrapperComp = (props) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const _modalDataStrategy =
      typeof modalDataStrategy === 'function'
        ? modalDataStrategy({ getI18n })
        : modalDataStrategy;
    const { value, onChange } = props;

    const [visible, setVisible] = React.useState<boolean>(false);
    const [delIndex, setDelIndex] = React.useState<number>(-1);

    const [modalData, setModalData] = React.useState(DEFAULTMODALDATA);

    const onOk = () => {
      if (delIndex !== -1) {
        onChange(
          value.filter((item, index) => index !== delIndex),
          'DEL',
        );
      }
      onCancel();
    };

    const onDelClick = (index: number) => {
      let modalType = 'delete';
      let context: any = {};
      if (getDelReason) {
        const reason = getDelReason({ list: value, index });
        const current = value[index];
        if (reason === 'SOURCE') {
          modalType = 'forbid';
          const sourceOf = (value || [])
            .filter(
              (item, i) =>
                i !== index &&
                item.translationSetting?.sourceLanguage === current.tag,
            )
            .map((item) => item.name);
          context = { current, sourceOf, reason };
        } else if (reason === 'PRIMARY') {
          modalType = 'confirm';
          context = { current, reason };
        } else {
          modalType = 'delete';
          context = { current, reason };
          setDelIndex(index);
        }
        setModalData({ ..._modalDataStrategy[modalType], context });
      } else if (canDel({ list: value, index })) {
        console.log('index', index);

        setModalData({ ..._modalDataStrategy.delete, context: {} });
        setDelIndex(index);
      } else {
        setModalData({ ..._modalDataStrategy.confirm, context: {} });
      }
      setVisible(true);
    };

    const onCancel = () => {
      setVisible(false);
      setDelIndex(-1);
      setModalData(DEFAULTMODALDATA);
    };

    const cancelButtonProps: any = {};

    if (modalData.buttonType === 'primary') {
      cancelButtonProps.style = {
        display: 'none',
      };
    }
    return (
      <React.Fragment>
        <Comp {...props} onDelClick={onDelClick} />
        <Modal
          title={modalData.title}
          visible={visible}
          okButtonProps={{
            type: modalData.buttonType,
          }}
          okText={modalData.okText || getI18n('general.confirm')}
          cancelButtonProps={cancelButtonProps}
          cancelText={getI18n('general.cancel')}
          width={600}
          maskClosable={false}
          onOk={onOk}
          onCancel={onCancel}>
          <div>
            {typeof modalData.content === 'function'
              ? modalData.content(modalData.context)
              : modalData.content}
          </div>
        </Modal>
      </React.Fragment>
    );
  };
  return WrapperComp;
};

export default ModalDelHOC;
